import { render, staticRenderFns } from "./KolnLevel.vue?vue&type=template&id=97d6e872&scoped=true&"
import script from "./KolnLevel.vue?vue&type=script&lang=js&"
export * from "./KolnLevel.vue?vue&type=script&lang=js&"
import style0 from "./KolnLevel.vue?vue&type=style&index=0&id=97d6e872&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d6e872",
  null
  
)

export default component.exports